module.exports = __webpack_public_path__ + "img/ic_vip.2d864cbe.svg";